const Types = {
  // Referrals
  referrals__refer_by_email: {
    title: 'Refer by Email',
    desc: 'Send a personal email to your friend or colleague.',
  },
  referrals__share_your_link: {
    title: 'Share Your Link',
    desc: 'Nobody can tell the SashiDo story better than our customers.',
  },
  referrals__virtual_wallet: {
    title: 'Virtual Wallet',
    desc: 'The Credits from your wallet will automatically be applied to your bills.',
  },
  referrals__give_30_days: {
    title: 'Give 30 days, Get $15 + 50k requests',
  },
  referrals__stats: {
    title: 'Stats',
    desc: 'Everyone you refer gets 30 days free on SashiDo. You get immediately 50K requests for your apps and once they\'ve spent $15 with us, you\'ll get $15',
  },
  settings__general_collaborators: {
    title: 'Collaborators',
    desc: 'Team up and work together with other people.',
    tutorials: 'https://blog.sashido.io/tag/collaborators/',
  },
  settings__push_push_notification_settings: {
    title: 'Push Notification Settings',
    desc: 'Secure push notifications for your app.',
    js_docs: 'http://docs.parseplatform.org/js/guide/#push-notifications',
    rest_docs: 'http://docs.parseplatform.org/rest/guide/#push-notifications',
  },
  settings__push_apple_push_certificates: {
    title: 'Apple Push Certificates',
    tutorials: 'https://blog.sashido.io/tag/ios-push-notifications/',
    github: 'https://github.com/SashiDo/sashido-ios-push-notification-sample',
    ios_docs: 'http://docs.parseplatform.org/ios/guide/#push-notifications',
  },
  settings__push_apple_push_tokens: {
    title: 'Apple Push Tokens',
    tutorials: 'https://blog.sashido.io/tag/ios-push-notifications/',
    // github: 'https://github.com/SashiDo/sashido-ios-push-notification-sample',
    ios_docs: 'http://docs.parseplatform.org/ios/guide/#push-notifications',
  },
  settings__push_android_push_credentials: {
    title: 'Android Push Credentials',
    desc: 'We encourage you to upgrade to FCM.',
    tutorials: 'https://blog.sashido.io/tag/android-push-notifications/',
    github: 'https://github.com/SashiDo/sashido-android-push-notification-sample',
    android_docs: 'http://docs.parseplatform.org/android/guide/#push-notifications',
  },
  settings__push_android_push_credentials_v2: {
    title: 'Android Push Credentials',
    tutorials: 'https://blog.sashido.io/tag/android-push-notifications/',
    github: 'https://github.com/SashiDo/sashido-android-push-notification-sample',
    android_docs: 'http://docs.parseplatform.org/android/guide/#push-notifications',
  },
  settings__emails_custom_domains: {
    title: 'Custom Domains',
    desc: 'Use this Parse app with your own custom URLs.',
    tutorials: 'https://blog.sashido.io/tag/custom-domains/',
    videos: 'https://www.youtube.com/watch?v=DT30lMk_rdQ&index=13&list=PLk66IKYX7bjrBKSNwNZVpTjVswA0oq5dr',
  },
  settings__emails_email_settings: {
    title: 'Email Settings',
    desc: 'Manage this app’s automated email communication.',
    videos: 'https://www.youtube.com/watch?v=WJSQQqxBuRg&index=18&list=PLk66IKYX7bjrBKSNwNZVpTjVswA0oq5dr',
  },
  settings__emails_email_templates: {
    title: 'Email Templates',
    desc: 'Customize the emails sent to your users when they manage their account information.',
    tutorials: 'https://blog.sashido.io/tag/email-templates/',
  },
  settings__emails_email_customize_user_facing_pages: {
    title: 'Customize User-Facing Pages',
    desc: 'These are the pages your users visit when managing their account information.<br />You can change these pages by uploading a modified copy to your own server.',
    tutorials: 'https://blog.sashido.io/tag/user-facing-pages/',
  },
  settings__live_queries_live_queries_classes: {
    title: 'Live Queries Classes',
    desc: 'Manage this app\'s live queries classes.',
    tutorials: 'https://blog.sashido.io/tag/livequeries/',
    github: 'https://gist.github.com/mignev/4e013e7bfd0d615d738aec01ab5aad5d',
    js_docs: 'http://docs.parseplatform.org/js/guide/#live-queries',
  },
  apps__api_console: {
    title: 'Send a test query',
    desc: 'Try out some queries, and take a look at what they return.',
    tutorials: 'https://blog.sashido.io/tag/api-console/',
    videos: 'https://www.youtube.com/watch?v=Aq4CAegumNs&list=PLk66IKYX7bjrBKSNwNZVpTjVswA0oq5dr&index=7',
  },
  apps__config: {
    tutorials: 'https://blog.sashido.io/tag/parse-config/',
    videos: 'https://www.youtube.com/watch?v=nqDajm7PGHk&index=11&list=PLk66IKYX7bjrBKSNwNZVpTjVswA0oq5dr',
    js_docs: 'http://docs.parseplatform.org/js/guide/#config',
    rest_docs: 'http://docs.parseplatform.org/rest/guide/#config',
    android_docs: 'http://docs.parseplatform.org/android/guide/#config',
    ios_docs: 'http://docs.parseplatform.org/ios/guide/#config',
  },
  apps__logs: {
    videos: 'https://www.youtube.com/watch?v=yhUL8yhc9xI&index=10&list=PLk66IKYX7bjrBKSNwNZVpTjVswA0oq5dr',
  },
  apps__jobs: {
    tutorials: 'https://blog.sashido.io/tag/background-jobs/',
    videos: 'https://www.youtube.com/watch?v=200nsnA0Gh0&index=9&list=PLk66IKYX7bjrBKSNwNZVpTjVswA0oq5dr',
    js_docs: 'http://docs.parseplatform.org/cloudcode/guide/#cloud-jobs',
  },
  apps__webhooks: {
    tutorials: 'https://blog.sashido.io/tag/webhooks/',
    videos: 'https://www.youtube.com/watch?v=igGsAad6fn0&list=PLk66IKYX7bjrBKSNwNZVpTjVswA0oq5dr&index=8',
    js_docs: 'http://docs.parseplatform.org/cloudcode/guide/#cloud-code-webhooks',
  },
  apps__backups: {
    videos: 'https://www.youtube.com/watch?v=mT0BeSWfqa0&index=17&list=PLk66IKYX7bjrBKSNwNZVpTjVswA0oq5dr',
  },
  apps__cloud_code: {
    tutorials: 'https://blog.sashido.io/tag/cloud-code/',
    videos: 'https://www.youtube.com/watch?v=Wm8wv3biWkc&index=6&list=PLk66IKYX7bjrBKSNwNZVpTjVswA0oq5dr',
    js_docs: 'http://docs.parseplatform.org/cloudcode/guide/',
  },
  runntime__env_variables: {
    title: 'Environment Variables',
    desc: 'An environment variable is a dynamic-named value that can affect the way running processes will behave on a computer.',
    tutorials: 'https://blog.sashido.io/tag/environment-variables/',
  },
  runntime__engines: {
    title: 'Engine',
    desc: "Don't slow down for a moment!<br />Take control of your capacity and Power up your app for success!",
    tutorials: 'https://blog.sashido.io/tag/engines/',
  },

  runntime__parse_version: {
    title: 'Parse Server Version',
    desc: 'Change your Parse Server version to the latest stable one.',
    tutorials: 'https://blog.sashido.io/tag/parse-server/',
  },
};

export default Types;
